<template>
  <v-dialog :value="value" max-width="900" @input="$emit('input', $event)">
    <v-card class="nc-preview">
      <v-card-title class="nc-title"><span>Nota de credito <span class="nc-ncf">{{ registro && registro.ncf_devolucion }}</span></span><v-spacer />
        <v-btn icon :disabled="!listo" title="Imprimir nota de credito" aria-label="Imprimir nota de credito" @click="imprimir"><v-icon>mdi-printer</v-icon></v-btn>
        <v-btn icon :disabled="!url" :href="url || undefined" :download="archivo" title="Descargar PDF" aria-label="Descargar PDF"><v-icon>mdi-download</v-icon></v-btn>
        <v-btn icon title="Cerrar vista previa" aria-label="Cerrar vista previa" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-progress-linear v-if="cargando || url && !listo && !error" indeterminate aria-label="Generando PDF" />
      <v-alert v-if="error" type="error" outlined class="ma-4" role="alert">{{ error }}
        <v-btn small text :disabled="cargando" @click="cargar">Reintentar</v-btn>
      </v-alert>
      <div v-if="url" class="nc-pdf" aria-label="Vista previa de nota de credito">
        <vue-pdf-embed ref="pdf" :source="url" @rendered="listo = true" @loading-failed="falloPdf" @rendering-failed="falloPdf" />
      </div>
      <div v-else class="nc-vacio" role="status">{{ cargando ? 'Generando vista previa...' : '' }}</div>
    </v-card>
  </v-dialog>
</template>
<script>
import { crearApi } from './api';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
export default {
  name: 'NotaCreditoPreview',
  components: { VuePdfEmbed },
  props: { value: Boolean, registro: Object },
  data: () => ({ url: '', cargando: false, listo: false, error: '', peticion: 0 }),
  computed: { archivo() { return 'Nota-credito-' + String(this.registro && this.registro.ncf_devolucion || '').replace(/[^A-Za-z0-9-]/g, '') + '.pdf'; } },
  watch: { value(abierto) { if (abierto) this.cargar(); else this.limpiar(); } },
  beforeDestroy() { this.limpiar(); },
  methods: {
    limpiar() { this.peticion++; if (this.url) URL.revokeObjectURL(this.url); this.url = ''; this.cargando = false; this.listo = false; },
    async cargar() {
      this.limpiar(); this.error = ''; this.cargando = true;
      const solicitud = this.peticion;
      try {
        const pdf = await crearApi(this).notaCreditoPdf(this.registro.id);
        if (solicitud !== this.peticion || !this.value) return;
        if (!(pdf instanceof Blob) || !pdf.size || !pdf.type.includes('application/pdf')) throw new Error('El servidor no devolvio un PDF valido.');
        this.url = URL.createObjectURL(pdf);
      } catch (e) {
        let mensaje = 'No se pudo cargar la vista previa. Verifique su conexion e intente nuevamente.';
        const data = e.response && e.response.data;
        if (data instanceof Blob) {
          try { const body = JSON.parse(await data.text()); mensaje = body.message || mensaje; } catch (_) { /* Keep the readable fallback. */ }
        } else if (data && data.message) mensaje = data.message;
        if (solicitud === this.peticion) this.error = mensaje;
      } finally { if (solicitud === this.peticion) this.cargando = false; }
    },
    falloPdf() { this.error = 'No se pudo mostrar el PDF. Puede descargarlo o volver a intentar.'; },
    async imprimir() {
      try { await this.$refs.pdf.print(203, this.archivo, true); }
      catch (_) { this.error = 'El navegador no pudo abrir la impresion. Descargue el PDF para imprimirlo.'; }
    },
  },
};
</script>
<style scoped>
.nc-preview { border-radius: 4px; }
.nc-title { display: flex; flex-wrap: wrap; gap: 4px; font-size: 17px; line-height: 1.4; }
.nc-title > span { overflow-wrap: anywhere; flex: 1 1 100%; }
.nc-ncf { display: inline-block; white-space: nowrap; }
.nc-pdf { display: block; width: 100%; height: 72vh; overflow: auto; padding: 18px; background: #525659; }
.nc-pdf > div { width: 100%; max-width: 420px; margin: 0 auto; }
.nc-vacio { min-height: 250px; display: flex; align-items: center; justify-content: center; }
</style>
